export default function ThreatAssessmentDirective() {
  return {
    template: require('./enterprise-threat-assessment.html'),
    scope: {
      assessmentId: '=',
      status: '@',
    },
    controller: 'EnterpriseThreatAssessmentController',
    controllerAs: 'enterpriseThreatAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
